// extracted by mini-css-extract-plugin
export default {"service_term":"Service_service_term__V6qiC"};